module.exports = "/_next/static/images/slide1-160180fe55c4bec37bcc362d61fde14c.jpg.webp";